<div class="sidebar-container side-nav bg-blue">
  <div class="">
    <a routerLink="/" routerLinkActive="active">
      <img class="logo-f sidebar-logo -mt-20" src="/assets/flogo.png" alt="" />
    </a>
    <!-- <img class="" src="/assets/d-logo.png" alt=""> -->
  </div>
  <div class="sidebar">
    <ul class="sidebar-navigation">
      <a  [routerLinkActiveOptions]={exact:true} routerLink="/dashboard" routerLinkActive="active">
        <li class=" ">
          <div class="center">
            <div>

              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" viewBox="0 0 25 25">
                <defs>
                  <style>.a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.727px;}</style>
                  <clipPath id="a">
                    <rect class="a" width="25" height="25" transform="translate(35 227)" />
                  </clipPath>
                </defs>
                <g class="b" transform="translate(-35 -227)">
                  <g transform="translate(37.273 228.136)">
                    <path [routerLinkActiveOptions]={exact:true} routerLink="/dashboard" routerLinkActive="active" class="c" d="M4.091,10.682,14.318,2.727l10.227,7.955v12.5a2.273,2.273,0,0,1-2.273,2.273H6.364a2.273,2.273,0,0,1-2.273-2.273Z" transform="translate(-4.091 -2.727)" />
                    <path [routerLinkActiveOptions]={exact:true} routerLink="/dashboard" routerLinkActive="active" class="c" d="M12.273,27.727V16.364h6.818V27.727" transform="translate(-5.455 -5)" />
                  </g>
                </g>
              </svg>


            </div>
          <span class="tcenter">Dashboard</span>
          </div>
        </li></a
      >
      <a routerLink="/plan" routerLinkActive="active">
        <li>
          <div class="center">
            <div>
              <img src="/assets/globe.svg" alt="" />
            </div>
            <span class="tcenter">Data Plans</span>
          </div>
        </li>
      </a>
      <a routerLink="/connectus" routerLinkActive="active">
        <li>
          <div class="center">
            <img src="/assets/wave.svg" alt="" />
            <span class="tcenter">Connect Us</span>
          </div>
        </li>
      </a>

      <a routerLink="/dashboard" >
        <li>
          <div class="center">
            <img src="/assets/profile.svg" alt="" /><span class="tcenter"
              >My Account</span
            >
          </div>
        </li>
      </a>
    </ul>
    <ul class="sidebar-navigation">
      <li>
        <div class="center">
          <img src="/assets/setting.svg" alt="" /><span class="tcenter">
            Settings</span
          >
        </div>
      </li>

      <li>
        <div class="center">
          <img src="/assets/logout.svg" alt="" />
          <span class="tcenter">Log out</span>
        </div>
      </li>
    </ul>
  </div>
</div>
